import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Input, Button, Popup, Icon } from 'semantic-ui-react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Buttons from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Block from '@material-ui/icons/Block';
import Alarm from '@material-ui/icons/Alarm';
import Equalizer from '@material-ui/icons/Equalizer';


import Loading from '../loading';
import Server from '../../functions/server';
import ReadCookie from '../../functions/readcookies';
import PendingStocks from './v1/pendingstocks';


const styles = {
  appBar: { position: 'relative', }, flex: { flex: 1, },
};

function Transition(props) { return <Slide direction="up" {...props} />; }

class FullScreenDialog extends React.Component {

  state = {
    data: []
  };

  getItems() {
    let context = this;
    context.setState({ load: true, message: 'Getting Items' });
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'id': context.props.id },
      url: Server() + 'stockaudit/getitems.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          data.map((c) => { c.item = false; })
          data = context.arrangeData(data);
          context.setState({ data, open: true, load: false, userId });
        } catch (e) { alert('Error'); context.setState({ load: false }) }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  arrangeData(datas) {
    let data = [];
    datas.map((c) => {
      if (c.adjustment == '1' || c.adjustment == 1) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '0' || c.adjustment == 0) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '2' || c.adjustment == 2) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '-1' || c.adjustment == -1) {
        data.push((c));
      }
    })
    return data;
  }

  stockAdjustment() {
    let context = this;
    let data = this.state.data;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let partno, branch, brand, closing, branchStock;
    let val = this.state.stockId;
    data.map((x) => {
      if (x.id == val) {
        partno = x.partno; brand = x.brand_id;
        closing = x.closing_stock; branchStock = x.branch_stock;
        branch = x.branch_id;
      }
    });
    context.setState({ load: true, message: 'Stock adjustments!!!' })
    $.ajax({
      type: 'POST',
      data: { 'partno': partno, 'branch': branch, 'brand': brand, 'branchStock': branchStock, 'id': val, 'userId': userId },
      url: Server() + 'stockaudit/stockadjustment.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          let item = context.state.data;
          item.map((x) => {
            if (x.id == val) { x.adjustment = '1'; }
          });
          item = context.arrangeData(item);
          context.setState({ data: item, opens: false, load: false })
        }
        else {
          alert('Trsy Again!!!');
          context.setState({ load: false })
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  conformed(id, value) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    if (userId == 6 || userId == 13 || userId == 1 || userId == 21) {
      let data = this.state.data;
      let partno, branch, brand, closing, branchStock;
      let val = this.state.stockId;
      data.map((x) => {
        if (x.id == id) {
          partno = x.partno; brand = x.brand_id;
          closing = x.closing_stock; branchStock = x.branch_stock;
          branch = x.branch_id;
        }
      });
      context.setState({ load: true, message: 'Stock Adjustment!!!' })
      $.ajax({
        type: 'POST',
        data: { 'partno': partno, 'branch': branch, 'brand': brand,
                'branchStock': branchStock, 'id': id, 'value': value, 'by': userId },
        url: Server() + 'stockaudit/conformstockadjustment.php',
        success: function(data) {
          if (data == 1) {
            let f = context.state.data;
            f.map((c) => { if (c.id == id) { c.adjustment = value; } })
            f = context.arrangeData(f);
            context.setState({ data: f, openAdminConform: false, load: false })
          }
          else {
            alert('Error!!!');
            context.setState({ load: false });
          }
        },
        error: function(e) {
          alert('Try again!!')
          context.setState({ load: false });
        }
      });
    }
  }

  openAdminConform(id) {
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    if (userId == 6 || userId == 13 || userId == 1 || userId == 21) {
      this.setState({ AdminAdjustment: id, openAdminConform: true })
    }
  }

  convertToNumber(value) {
    try {
      value = Number(value)
    } catch (e) {
      value = 0;
    }
    return value;
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    let i = 1;
    let userId = this.convertToNumber(this.state.userId);
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <u style={{color: 'blue'}} onClick={this.getItems.bind(this)}>View</u>
        <Dialog fullScreen open={this.state.open}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ open: false }) }} aria-label="Close">
              <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {'Stock Audit Id: '+this.props.id}
              </Typography>
            </Toolbar>
          </AppBar>
          <div style={{padding: '0.5%'}}>
            <div style={{display: 'flex', marginBottom: 5}}>
              <div>
                <PendingStocks title={'Stocks Pending For Verification'} data={this.state.data} value={0} save={ (data) => { this.setState({ data }) } } />
              </div>
              <div style={{marginLeft: 5}}>
                { userId == 6 || userId == 153 || userId == 1 || userId == 21 || userId == 13 ?
                  (<PendingStocks title={'Stocks Pending For Approve'} data={this.state.data} value={1} save={ (data) => { this.setState({ data }) } } />):''
                }
              </div>
            </div>
            <table width="100%" id="table">
              <tr>
                <th id="tableheader" style={{fontSize: 12, width: '6%'}}><center>Sino</center></th>
                <th id="tableheader" style={{fontSize: 12}}><center>Spare</center></th>
                <th id="tableheader" style={{fontSize: 12, width: '10%'}}><center>Brand</center></th>
                <th id="tableheader" style={{fontSize: 12, width: '10%'}}><center>Closing Stock</center></th>
                <th id="tableheader" style={{fontSize: 12, width: '10%'}}><center>Branch Stock</center></th>
                <th id="tableheader" style={{fontSize: 12, width: '7%'}}><center>Stock Differ</center></th>
                <th id="tableheader" style={{fontSize: 12, width: '6%', display: this.props.stockauditedit}}><center>Adj</center></th>
              </tr>
              <tbody>
                {
                  this.state.data.map((x) => {
                    let closingStock = x.closing_stock;
                    let branchStock = x.branch_stock; let differ = 0;
                    let icon = (<Equalizer
                      onClick={ () => { this.setState({ stockId: x.id, opens: true }) } }
                      style={{color: '#406FCF'}} />);
                    if (x.adjustment == 1) {
                      icon = (
                        <Alarm name='check circle' style={{fontSize: 17}} style={{color: '#EB8017'}}
                        onClick={this.openAdminConform.bind(this, x.id)}  />
                      );
                    }
                    if (x.adjustment == 2) {
                      icon = (<Icon name='check circle' style={{color: 'green'}} />);
                    }
                    if (x.adjustment == -1) {
                      icon = (<Block name='check circle' style={{color: 'red'}} />);
                    }
                    try {
                      closingStock = Number(closingStock);
                      branchStock = Number(branchStock);
                      differ = branchStock - closingStock;
                    } catch (e) { }
                    return (
                      <Popup content={x.remark}
                        trigger={<tr>
                          <td><center>{i++}</center></td>
                          <td>{x.partno+"->"+x.spare_name}</td>
                          <td>{x.brand_name+"("+x.brand_id+")"}</td>
                          <td><center>{x.closing_stock}</center></td>
                          <td><center>{x.branch_stock}</center></td>
                          <td><center>{differ}</center></td>
                          <td id='pointer' style={{display: this.props.stockauditedit}}><center>{icon}</center></td>

                        </tr>} />
                    )
                  })
                }
              </tbody>
            </table>

            <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1} open={this.state.opens}
              onClose={ () => { this.setState({ opens: false }) }} aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">Conformation</DialogTitle>
              <DialogContent>Conform to stock Adjustment!!!</DialogContent>
              <DialogActions>
                <Button onClick={ () => { this.setState({ opens: false }) }} color="primary">Close</Button>
                <Button onClick={this.stockAdjustment.bind(this)} color="primary">Submit</Button>
              </DialogActions>
            </Dialog>

            <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1} open={this.state.openAdminConform}
              onClose={ () => { this.setState({ openAdminConform: false }) }} aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">Conformation</DialogTitle>
              <DialogContent>Stock Adjustment!!!</DialogContent>
              <DialogActions>
                <Button onClick={this.conformed.bind(this, this.state.AdminAdjustment, -1)} color="primary">Reject</Button>
                <Button onClick={this.conformed.bind(this, this.state.AdminAdjustment, 2)} color="primary">Conform</Button>
                <Button onClick={ () => { this.setState({ openAdminConform: false }) }} color="primary">Close</Button>
              </DialogActions>
            </Dialog>
          </div>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(FullScreenDialog);
